export enum EImageAssetSourceType {
  Uploaded = 0,
  ExternalUrl = 1,
  Edited = 2,
}
